export enum BeneficiaryDrawerParams {
  ClaimSetNumber = 'claimSetNumber',
  BeneficiaryId = 'beneficiaryId',
  ClaimId = 'claimId',
  Highlight = 'highlight',
  Expanded = 'expanded',
}
